import {CUE_CARD_COLLECTION} from '../consts/cue-card-collection';

/**
 * Returns true if the pagePath has CueCards defined in the CUE_CARD_COLLECTION.
 *
 * @param pagePath
 * @returns {boolean}
 */
export const pageHasGlossary = (pagePath: string): boolean => {
    const cueCardsForPage = CUE_CARD_COLLECTION[pagePath];

    return Boolean(
        cueCardsForPage &&
            cueCardsForPage.cards.find((card) => card.location !== 'settings-sidebar')
    );
};
